import styled, { css } from 'styled-components'
import { colors, derivedColors, withScrollbarStyled } from '../../../const'
import { STATUS } from '../../../const/status'

const thumbnailDotColor = ({ image, $showQualityStatus }) => {
  if (!$showQualityStatus || !image) return 'transparent'
  return colors.surface
}

const thumbnailStatusColor = ({ image, $showQualityStatus, $status }) => {
  if (!$showQualityStatus || !image) return 'transparent'
  return STATUS[$status] || 'transparent'
}

export const Container = styled.div(
  ({ isVisible }) => css`
    display: ${isVisible ? 'flex' : 'none'};
    flex-direction: column;
    font-family: 'Inter';
    width: 100%;
  `
)

export const PrincipalImageInfo = styled.div`
  align-items: center;
  border-bottom: 2px solid rgba(211, 218, 230, 0.5);
  display: flex;
  height: 50px;
  justify-content: space-between;
  width: 100%;
`

export const PrincipalImageText = styled.p`
  color: ${colors.primary};
  font-size: 0.875rem;
  overflow: hidden;
  padding-left: 3%;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 90%;
`

export const ImagesContainer = styled.div`
  display: flex;
  height: 100%;
  padding: 2% 0 0;
  width: 100%;
`

export const PrincipalImageContainerPercentage = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`

export const ThumbnailsContainer = styled.ol`
  margin: 0;
  max-height: 450px;
  min-height: 450px;
  overflow-y: auto;
  padding: 0 0 2% 0;
  width: 18%;

  counter-reset: counter-name 0;
  ${withScrollbarStyled}
`

export const ThumbnailCounterWrapper = styled.li(
  () => css`
    margin: 0 auto;
    position: relative;

    &::before {
      color: ${colors.primary};
      content: counter(counter-name);
      counter-increment: counter-name;
      width: 10px;
      height: 10px;
      z-index: 2;
      position: absolute;
    }
  `
)

export const ThumbnailWrapper = styled.div(
  ({ selected, image, $showQualityStatus, $status }) => css`
    align-items: center;
    background-color: ${derivedColors.subtleSurface};
    border: 4px solid ${selected ? colors.primary : 'transparent'};
    cursor: pointer;
    display: flex;
    height: 64px;
    justify-content: center;
    margin: 12px auto;
    position: relative;
    width: 64px;

    &::before {
      background-color: ${thumbnailDotColor({ image, $showQualityStatus })};
      border-radius: 50%;
      content: '';
      height: 14px;
      right: -6px;
      position: absolute;
      top: -6px;
      width: 14px;
      z-index: 1;
    }

    &::after {
      background-color: ${thumbnailStatusColor({ image, $showQualityStatus, $status })};
      border-radius: 50%;
      content: '';
      height: 10px;
      right: -4px;
      position: absolute;
      top: -4px;
      width: 10px;
      z-index: 1;
    }
  `
)

export const ThumbnailImage = styled.img`
  max-height: 56px;
  max-width: 100%;
  position: relative;
`
export const NoImageMessage = styled.p`
  color: ${derivedColors.attenuated};
  font-size: 1rem;
  margin: 0;
  padding: 20px 0;
  text-align: center;
  width: 100%;
`

export const PrincipalImageContainer = styled.div(
  ({ inTheCenter }) => css`
    align-items: ${inTheCenter ? 'center' : 'flex-start'};
    background-color: black;
    min-height: 450px;
    display: flex;
    justify-content: center;
    position: relative;
    width: 100%;
  `
)

export const PercentageStatisticsContainer = styled.div`
  align-items: stretch;
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: center;
  padding-top: 15px;
  width: 100%;
`

export const PredictionCard = styled.section`
  background-color: ${colors.surface};
  border: 1px solid ${colors.borderSubtle};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px 14px;
  width: 100%;
`

export const CardHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export const CardTitle = styled.h2(({ $primary }) => css`
  color: ${$primary ? colors.primary : colors.textPrimary};
  font-size: 0.96rem;
  font-weight: 700;
  margin: 0;
`)

export const CardBadge = styled.span`
  background-color: ${derivedColors.transparentSecondary};
  border: 1px solid ${derivedColors.transparentSecondaryHover};
  border-radius: 999px;
  color: ${colors.primary};
  font-size: 0.69rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  padding: 3px 8px;
  text-transform: uppercase;
`

export const FloatingMenu = styled.div(
  () => css`
    align-items: center;
    background-color: transparent;
    display: flex;
    gap: 10px;
    left: 0;
    padding: 16px;
    position: absolute;
    top: 0;
  `
)

export const IAToggler = styled.div(
  ({ active, withGap }) => css`
    align-items: center;
    background-color: ${active ? colors.primary : derivedColors.attenuated};
    border-radius: 2px;
    cursor: pointer;
    display: flex;
    height: 38px;
    gap: ${withGap ? '6px' : '0'};
    justify-content: space-evenly;
    left: 20px;
    padding: 6px 8px;
    top: 10px;

    &:hover {
      background-color: ${colors.primaryHover};
    }
  `
)

export const TogglerText = styled.p`
  color: white;
  font-family: 'Inter';
  font-weight: 500;
  font-size: 1rem;
  margin: 0 4px;
`

export const TogglerIcon = styled.img`
  margin: 0 4px;
`

export const ImageContainer = styled.div`
  align-items: center;
  display: flex;
  height: 60%;
  justify-content: center;
  width: 80%;
    overflow: hidden;
`
export const PrincipalImage = styled.img.attrs(props => ({
  style: {
    height: '100%',
    maxWidth: '100%',
    width: '100%',
    objectFit: 'contain',
    transform: `scale(${props.zoom}) translate(${props.x}px, ${props.y}px)`,
    cursor: props.zoom > 1 ? 'grab' : 'auto',
    userSelect: 'none'
  }
}))``

export const RadioWrapper = styled.div`
  background-color: ${colors.surface};
  border-radius: 3px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 4px;
  position: absolute;
  top: 60px;
`

export const RadioInput = styled.input`
  
`
export const Title = styled.h1`
  color: ${colors.primary};
  font-size: 1rem;
  font-weight: 700;
  margin: 0;
`

export const StatisticsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  font-family: 'Inter';
  margin: 0;
  padding: 6px 0 8px;
  width: 100%;
  justify-content: center;
`

export const StatisticsText = styled.p`
  color: ${colors.textSecondary};
  font-size: 0.875rem;
  font-weight: 500;
  margin: 4px 0;
`

export const StatisticsElement = styled.div(({ display }) => css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 50%;
  display: ${display === 0 && 'none'}
`
)
export const StatisticsPercentage = styled.div`
  width: 80%;
`

export const RadioLabel = styled.label`
  padding: 4px;
  white-space: nowrap;
`

export const SecondaryMetricsGrid = styled.div`
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-top: 0;
  width: 100%;

  @media screen and (max-width: 940px) {
    grid-template-columns: 1fr;
  }
`

export const SecondaryMetric = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`

export const SecondaryMetricLabel = styled.p`
  color: ${colors.textSecondary};
  font-size: 0.82rem;
  font-weight: 500;
  margin: 0;
`

export const SecondaryMetricBar = styled.div`
  width: 100%;
`

const qualityButtonColor = (quality) => {
  if (quality === 'buena') return colors.success
  if (quality === 'aceptable') return colors.warning
  if (quality === 'mala') return colors.error
  return colors.primary
}

const qualityButtonTextColor = (quality) => {
  if (quality === 'aceptable') return colors.textPrimary
  return colors.surface
}

export const QualityActionButton = styled.button(({ $quality }) => css`
  align-items: center;
  background-color: ${qualityButtonColor($quality)};
  border: 1px solid ${qualityButtonColor($quality)};
  border-radius: 999px;
  bottom: 16px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.35);
  color: ${qualityButtonTextColor($quality)};
  cursor: pointer;
  display: flex;
  gap: 8px;
  min-height: 36px;
  padding: 8px 12px;
  position: absolute;
  right: 16px;
  z-index: 6;
`)

export const QualityActionText = styled.span`
  font-size: 0.75rem;
  font-weight: 700;
`

export const QualityMenu = styled.div`
  background: ${colors.surface};
  border: 1px solid ${colors.borderSubtle};
  border-radius: 8px;
  bottom: 60px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 210px;
  padding: 10px;
  position: absolute;
  right: 16px;
  z-index: 7;
`

export const QualityMenuTitle = styled.p`
  color: ${colors.textPrimary};
  font-size: 0.74rem;
  font-weight: 700;
  margin: 0 0 2px;
`

export const QualityMenuOption = styled.button(({ $active, $quality }) => css`
  align-items: center;
  background: ${$active ? derivedColors.transparentSecondary : colors.surface};
  border: 1px solid ${$active ? qualityButtonColor($quality) : colors.borderSubtle};
  border-radius: 6px;
  color: ${colors.textPrimary};
  cursor: pointer;
  display: flex;
  font-size: 0.78rem;
  font-weight: 600;
  justify-content: space-between;
  padding: 7px 9px;
  width: 100%;
`)
